import { render, staticRenderFns } from "./GroupsForm.vue?vue&type=template&id=2250a0de&"
import script from "./GroupsForm.vue?vue&type=script&lang=js&"
export * from "./GroupsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports